<div [innerHTML]="customContent$ | async">

</div>
